exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sold .md-table .md-table-cell.actions-cell[data-v-4ec6a6ce]{width:254px;max-width:254px}.error[data-v-4ec6a6ce]{font-size:22px;margin:100px 0 50px;text-align:center;color:rgba(0,0,0,.87);font-weight:400}.stornoInput[data-v-4ec6a6ce]{resize:none;height:150px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ec6a6ce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Tickets/Sold.vue
// module id = 244
// module chunks = 0